<template>
  <div class="d-flex flex-column" style="min-height: 100vh">
    <!-- main content -->
    <div style="flex: 1">
      <!-- logo -->
      <logo_display></logo_display>
      <!-- logo -->

      <!-- heading -->
      <page_banner page_title="箱積分計算及預填購貨表格" />
      <!-- heading -->

      <b-container fluid class="mt-5">
        <!-- alert_message -->
        <b-container
          class="d-flex justify-content-center align-content-center mt-3"
          v-if="alert_message"
        >
          <b-alert show variant="danger">{{ alert_message }}</b-alert>
        </b-container>
        <!-- alert_message -->

        <b-container
          class="d-flex flex-column justify-content-center align-content-center mt-3"
          v-else
        >
          <!-- input form -->
          <form @submit.prevent="enter_product">
            <b-input-group size="lg" class="mb-2">
              <b-form-input
                v-model="search_word"
                placeholder="輸入產品名稱或ID"
                class="text-center"
                list="search_input"
                :state="search_warning"
                required
                ref="search_input_box"
              />
              <b-form-input
                v-model="qty"
                placeholder="輸入數量"
                class="text-center"
                type="number"
                inputmode="numeric"
                min="1"
                required
              />
              <datalist id="search_input">
                <option v-for="word in search_list" :key="word">
                  {{ word }}
                </option>
              </datalist>
              <b-form-invalid-feedback>
                {{ search_warning_sentence }}</b-form-invalid-feedback
              >
            </b-input-group>

            <!-- <div class="mt-3 mx-3 d-flex flex-sm-row justify-content-around"> -->
            <div class="mt-3 mx-3 d-flex flex-row justify-content-around">
              <b-button
                type="submit"
                variant="outline-success"
                class="mx-2"
                size="lg"
                >加入</b-button
              >
              <b-button
                type="reset"
                variant="outline-danger"
                @click="reset_form"
                size="lg"
                class="mx-2"
                >重置</b-button
              >
              <b-button
                variant="outline-primary"
                id="pre_order_button"
                v-b-modal="'pre_order_form'"
                :disabled="count_list.length === 0"
                size="lg"
                class="mx-2"
                >預約購買</b-button
              >
            </div>
          </form>
          <!-- input form -->
          <!-- add product table -->
          <b-table
            v-if="count_list.length > 0"
            striped
            hover
            :fields="count_fields"
            :items="count_list"
            class="text-center mt-3"
          >
            <!-- delete product button -->
            <template #row-details="data">
              <b-button
                variant="outline-danger"
                size="sm"
                class="mb-2"
                @click="remove_product(data.item)"
              >
                移除
              </b-button>
            </template>
            <!-- delete product button -->

            <!-- edit product number button -->
            <template #cell(qty)="data">
              <b-form-input
                v-model="data.item.qty"
                class="text-center"
                type="number"
                size="lg"
                @change="edit_number()"
              >
              </b-form-input>
            </template>
          </b-table>
          <!-- edit product number button -->
          <!-- add product table -->

          <!-- counted rusult -->
          <transition name="fade">
            <b-table
              v-if="count_list.length > 0"
              stacked
              :fields="result_fields"
              :items="result_list"
              class="text-center"
            >
            </b-table>
          </transition>
          <!-- counted rusult -->
        </b-container>

        <!-- pre order form -->
        <b-modal
          hide-footer
          hide-header-close
          id="pre_order_form"
          title="產品清單"
          size="xl"
        >
          <!-- loading logo -->
          <b-container
            v-if="pre_order_loading"
            class="mt-5 mb-5 d-flex justify-content-center align-content-center"
          >
            <b-spinner variant="success" label="Spinning"></b-spinner>
          </b-container>
          <!-- loading logo -->

          <!-- pre order content -->
          <div v-if="pre_order_form_content">
            <!-- pre order content -->
            <b-container
              class="mt-5 mb-5 d-flex justify-content-center align-content-center"
            >
              <b-table
                :fields="count_fields"
                :items="count_list"
                class="text-center"
              >
              </b-table>
            </b-container>
            <!-- pre order content -->

            <!-- confirm form -->
            <form @submit.prevent="pre_order">
              <b-container
                class="mb-3 d-flex flex-column flex-sm-row justify-content-center align-content-center"
              >
                <b-form-input
                  v-model="pre_order_fbo_id"
                  type="text"
                  inputmode="numeric"
                  pattern="^\d{12}$"
                  maxlength="12"
                  placeholder="輸入 FBO ID"
                  required
                  size="lg"
                  class="mt-3 mb-3 mx-sm-3"
                ></b-form-input>
              </b-container>

              <b-form-group label="選擇付款地點">
                <b-form-radio-group
                  v-model="pre_order_pickup_point"
                  :options="pre_order_pickup_points"
                  button-variant="outline-primary"
                  buttons
                  stacked
                  required
                  class="d-flex justify-content-center"
                >
                </b-form-radio-group>
              </b-form-group>

              <b-button type="submit" variant="outline-success" size="lg" block>
                提交
              </b-button>
              <b-button
                @click="$bvModal.hide('pre_order_form')"
                variant="outline-secondary"
                size="lg"
                block
              >
                關閉
              </b-button>
            </form>
            <!-- confirm form -->
          </div>
          <!-- pre order content -->

          <!-- pre order qr code -->
          <b-container
            v-if="pre_order_qr_code"
            class="d-flex flex-column align-items-center justify-content-center"
          >
            <b-img :src="api_url + pre_order_qr_code_link" fluid width="200" />
            <b-alert variant="success" show class="text-center">
              <div>
                已成功預訂， 你的訂單編號是<br />
                <h1 style="display: inline">{{ pre_order_id }}</h1>
                <br />
                請截圖並交給職員
              </div>
            </b-alert>
            <b-button
              variant="outline-primary"
              size="lg"
              class="mb-3"
              @click="save_qr_code"
            >
              下載QR Code
            </b-button>
            <b-button
              @click="$router.go(0)"
              variant="outline-primary"
              size="lg"
            >
              完成
            </b-button>
          </b-container>
          <!-- pre order qr code -->
        </b-modal>
        <!-- pre order form -->
      </b-container>
    </div>
    <!-- main content -->

    <!-- footer -->
    <b-container class="d-flex justify-content-center">
      <b-alert variant="warning" class="mb-0" show>
        <ul class="list-unstyled ps-4 mb-0">
          <li class="note-item first-note">
            <span class="note-label"><b>備注:</b></span>
            <span class="note-number">1.</span>
            <span class="note-content"
              ><b>所有箱積分及價錢只作參考之用。</b></span
            >
          </li>
          <li class="note-item">
            <span class="note-label"></span>
            <span class="note-number">2.</span>
            <span class="note-content">
              <b>
                此「箱積分計算及預填購貨表格」功能，不能顯示產品庫存狀況。當有產品貨源不足或缺貨時，FBO可即場更改或取消訂貨單中的相關產品。
              </b>
            </span>
          </li>
        </ul>
      </b-alert>
    </b-container>
    <!-- footer -->
  </div>
</template>

<script>
import api from "@/api/index.js";
import page_banner from "./page_banner.vue";
import logo_display from "./logo_display.vue";

export default {
  data() {
    return {
      api_url: process.env.VUE_APP_API_URL,
      product_data: [],
      alert_message: null,
      search_word: null,
      search_list: [],
      search_warning: null,
      search_warning_sentence: null,
      qty: null,
      count_fields: [
        { key: "product_id", label: "產品ID", class: "text-center nowrap" },
        { key: "name", label: "產品名稱", class: "text-center" },
        { key: "qty", label: "購買數量", class: "text-center nowrap" },
      ],
      count_list: [],
      result_fields: [
        { key: "case_credit", label: "箱積分" },
        { key: "retail_price", label: "零售價" },
        { key: "pcp_price", label: "特選顧客價" },
        { key: "wholesale_price", label: "批發價" },
        // { key: "supervisor_price", label: "主管價" },
        // { key: "assistant_manager_price", label: "助理經理價" },
        // { key: "manager_price", label: "經理價" },
      ],
      result_list: [
        {
          retail_price: 0,
          pcp_price: 0,
          wholesale_price: 0,
          supervisor_price: 0,
          assistant_manager_price: 0,
          manager_price: 0,
          case_credit: 0,
        },
      ],
      pre_order_fbo_id: null,
      pre_order_pickup_point: null,
      pre_order_pickup_points: [],
      pre_order_loading: false,
      pre_order_form_content: true,
      pre_order_qr_code: false,
      pre_order_qr_code_link: "",
      pre_order_id: "",
      isMobile: window.innerWidth < 768,
    };
  },
  mounted() {
    window.addEventListener("resize", this.handle_resize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handle_resize);
  },
  async created() {
    try {
      // get product data and set product data
      let response = await api.get("/api/get_product_list");
      this.product_data = response.data;

      for (let product of this.product_data) {
        product["name"] = product.cname + " " + product.ename;
        product["_showDetails"] = true;

        this.search_list.push(product.product_id);
        this.search_list.push(product.cname);
        this.search_list.push(product.ename);
      }

      // get shop data and set pickup point
      response = await api.get("/api/get_shops_list");
      for (let shop of response.data) {
        this.pre_order_pickup_points.push({
          text: shop.cname,
          value: shop.id,
        });
      }
      // shot the tst pickup point to frist pleace
      let index = this.pre_order_pickup_points.findIndex(
        (point) => point.text === "永恆生活產品亞洲有限公司 尖沙咀營運中心",
      );
      if (index === 0) {
        return;
      }
      let [foundPoint] = this.pre_order_pickup_points.splice(index, 1);
      this.pre_order_pickup_points.unshift(foundPoint);

      console.log(this.pre_order_pickup_points);
    } catch (error) {
      console.log(error);

      this.alert_message = "網路連線錯誤";
    }
  },
  methods: {
    handle_resize() {
      this.isMobile = window.innerWidth < 768;
    },
    // handle add product
    enter_product() {
      // remove search word first word if it is 0
      if (this.search_word.charAt(0) === "0") {
        this.search_word = this.search_word.substring(1);
      }
      // check input product in count list or not
      let found = this.count_list.some(
        (product) =>
          Number(this.search_word) == Number(product.product_id) ||
          this.search_word == product.cname ||
          this.search_word == product.ename,
      );
      if (found) {
        this.search_warning = false;
        this.search_warning_sentence = "已有相同產品";
        return;
      }
      // check input product in product list or not , put in count list if in product list
      let product = this.product_data.find(
        (product) =>
          Number(this.search_word) == Number(product.product_id) ||
          this.search_word == product.cname ||
          this.search_word == product.ename,
      );
      if (product) {
        product["qty"] = this.qty;
        this.count_list.unshift(product);
        this.search_warning = null;
        this.compute_result();
      } else {
        this.search_warning = false;
        this.search_warning_sentence = "未能找到產品";
      }
      this.search_word = null;
      this.qty = null;
      this.$nextTick(() => this.$refs.search_input_box.focus());
    },
    // empty search box, qty box, warning sentence, count list
    reset_form() {
      this.count_list = [];
      this.search_word = null;
      this.search_warning = null;
      this.search_warning_sentence = "";
      this.qty = null;
    },
    // remove product from count list
    remove_product(item) {
      this.count_list = this.count_list.filter((i) => i !== item);
      this.compute_result();
    },
    // edit product number
    edit_number() {
      this.compute_result();
    },
    // compute count product result
    compute_result() {
      let formatter = new Intl.NumberFormat("zh-hk", {
        style: "currency",
        currency: "HKD",
      });
      let rl = this.result_list[0];
      let cl = this.count_list;

      let retail_price = 0;
      let pcp_price = 0;
      let wholesale_price = 0;
      let supervisor_price = 0;
      let assistant_manager_price = 0;
      let manager_price = 0;
      let cc = 0;

      for (let p of cl) {
        retail_price += p.retail_price * p.qty;
        pcp_price += p.pcp_price * p.qty;
        wholesale_price += p.wholesale_price * p.qty;
        supervisor_price += p.supervisor_price * p.qty;
        assistant_manager_price += p.assistant_manager_price * p.qty;
        manager_price += p.manager_price * p.qty;
        cc += p.case_credit * p.qty;
      }

      rl.retail_price = formatter.format(retail_price.toFixed(2));
      rl.pcp_price = formatter.format(pcp_price.toFixed(2));
      rl.wholesale_price = formatter.format(wholesale_price.toFixed(2));
      rl.supervisor_price = formatter.format(supervisor_price.toFixed(2));
      rl.assistant_manager_price = formatter.format(
        assistant_manager_price.toFixed(2),
      );
      rl.manager_price = formatter.format(manager_price.toFixed(2));
      rl.case_credit = cc.toFixed(3);
    },
    // order product
    async pre_order() {
      // set loading
      this.pre_order_loading = true;
      this.pre_order_form_content = false;

      // set data sended to server
      let pre_order_data = {
        fbo_id: this.pre_order_fbo_id,
        shop: this.pre_order_pickup_point,
        products: [],
      };

      // add product data to sended server data
      for (let p of this.count_list) {
        let product = {
          product_id: p.product_id,
          quantity: p.qty,
        };
        pre_order_data["products"].push(product);
      }
      console.log(pre_order_data);

      // send data to server
      try {
        const response = await api.post(
          "/api/create_pre_order/",
          pre_order_data,
        );
        if (response.data.status === "success") {
          this.pre_order_loading = false;
          this.pre_order_qr_code = true;
          this.pre_order_qr_code_link = response.data.qr_code;
          this.pre_order_id = response.data.order_id;
        } else {
          console.log(response.data.error);
          this.alert_message = response.alert_message;
        }
      } catch (err) {
        this.alert_message = "系統繁忙，請稍後再試。";
      }
    },
    save_qr_code() {
      // download
      const imageUrl =
        process.env.VUE_APP_API_URL + this.pre_order_qr_code_link;
      const fileName = `order${this.pre_order_id}.png`;

      fetch(imageUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url); // 釋放資源
        })
        .catch((error) => {
          console.error("下載失敗:", error);
        });

      // download to photo
      if (navigator.share) {
        fetch(process.env.VUE_APP_API_URL + this.pre_order_qr_code_link)
          .then((response) => response.blob())
          .then((blob) => {
            const filesArray = [
              new File([blob], `order${this.pre_order_id}.png`, {
                type: blob.type,
              }),
            ];
            navigator
              .share({
                files: filesArray,
                title: "保存圖片",
                text: "請保存此圖片到相簿",
              })
              .then(() => {
                console.log("分享成功");
              })
              .catch((error) => {
                console.error("分享失敗", error);
              });
          });
      } else {
        alert("您的瀏覽器不支援分享功能");
      }
    },
  },
  components: {
    logo_display,
    page_banner,
  },
};
</script>

<style>
.nowrap {
  white-space: nowrap;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
@media (max-width: 576px) {
  .form-control::placeholder {
    font-size: 0.75rem;
  }
  .btn {
    width: 100%;
    margin-bottom: 10px !important;
  }
}

.sticky-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 1030;
}

.note-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
}

.first-note {
  align-items: baseline; /* 確保第一行基線對齊 */
}

.note-label {
  width: 60px; /* 固定“備注:”寬度 */
  flex-shrink: 0;
  margin-right: 8px;
}

.note-number {
  width: 30px; /* 固定編號寬度，確保對齊 */
  flex-shrink: 0;
  text-align: right;
  padding-right: 8px;
}

.note-content {
  flex: 1; /* 內容佔據剩餘空間 */
}
</style>
